export default __webpack_public_path__ + "static/media/execute_examReults.684a3564.png";